var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point-link",class:{ custom: _vm.havMargin }},[_c('SvgIcon',{staticClass:"point-pink__icon",attrs:{"width":_vm.iconSize,"height":_vm.iconSize,"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }